import React from 'react';
import { IMPORT_STEP_LABELS } from './importConstants';

type ImportStep = keyof typeof IMPORT_STEP_LABELS;

interface ImportStepIndicatorProps {
  currentStep: ImportStep;
}

const STEPS: ImportStep[] = ['input', 'review', 'importing', 'complete'];

export const ImportStepIndicator: React.FC<ImportStepIndicatorProps> = ({ currentStep }) => {
  const currentIndex = STEPS.indexOf(currentStep);

  return (
    <nav aria-label="Import progress" className="flex items-center justify-center mb-4 sm:mb-6">
      <ol className="flex items-center gap-1 sm:gap-4">
        {STEPS.map((step, index) => {
          const isComplete = currentIndex > index;
          const isCurrent = currentStep === step;
          const label = IMPORT_STEP_LABELS[step];

          return (
            <li key={step} className="flex items-center gap-1 sm:gap-4">
              <div className="flex flex-col items-center gap-1 min-w-[3rem] sm:min-w-0">
                <div
                  className={`flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-full border-2 text-xs sm:text-sm font-medium ${
                    isCurrent
                      ? 'border-orange-500 bg-orange-500 text-white'
                      : isComplete
                        ? 'border-orange-500 bg-orange-500 text-white'
                        : 'border-white/[0.10] bg-[#161616] text-gray-400'
                  }`}
                  aria-current={isCurrent ? 'step' : undefined}
                >
                  {isComplete ? (
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" aria-hidden>
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    index + 1
                  )}
                </div>
                <span
                  className={`text-[10px] sm:text-xs ${
                    isCurrent ? 'text-orange-300 font-medium' : 'text-gray-500'
                  }`}
                >
                  {label}
                </span>
              </div>
              {index < STEPS.length - 1 && (
                <div
                  className={`hidden sm:block w-8 lg:w-12 h-0.5 mb-4 ${
                    currentIndex > index ? 'bg-orange-500' : 'bg-[#1a1a1a]'
                  }`}
                  aria-hidden
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
